var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.3666C9.33333 15.3666 14 9.98033 14 6.66663C14 3.35292 11.3137 0.666626 8 0.666626C4.68629 0.666626 2 3.35292 2 6.66663C2 9.98033 6.66667 15.3666 8 15.3666ZM8.00006 7.66663C9.10463 7.66663 10.0001 6.7712 10.0001 5.66663C10.0001 4.56206 9.10463 3.66663 8.00006 3.66663C6.8955 3.66663 6.00007 4.56206 6.00007 5.66663C6.00007 6.7712 6.8955 7.66663 8.00006 7.66663Z",
    fill: "#6E777C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPicker);
export default __webpack_public_path__ + "static/media/icon-picker.9149f153536994377815ac5e6f5ae2f8.svg";
export { ForwardRef as ReactComponent };